
import { mapGetters } from 'vuex'
import LolePicture from '~/components/picture/lole-picture.vue'
export default {
  components: { LolePicture },
  computed: {
    ...mapGetters({
      vxSearchResults: 'search/getSearchResults',
    }),
  },
  methods: {
    isExternalLink(link) {
      return !!link.includes('http')
    },
  },
}
